export default "uniform highp vec4 u_color;\r\n\r\nvoid main() {\r\n    gl_FragColor = u_color;\r\n}\r\n";